export class TesoreriaDTO {
	numeroConto: string;
	tesoreria: string;
}